export default [
    {
        path: "/",
        name: "i",
        component: (resolve) => import("./pages/viewport.vue"),
        meta: {
            title: "个人中心",
            auth: true,
        },
        children: [
            {
                path: "",
                meta: {
                    title: "用户中心",
                    auth: true,
                },
                component: (resolve) => import("./pages/home/index.vue"),
            },
            {
                path: "order",
                name: "order",
                meta: {
                    title: "订单中心",
                    auth: true,
                },
                component: (resolve) => import("./pages/order/index"),
            },
            {
                path: "order/:id",
                name: "order.show",
                meta: {
                    title: "订单详情",
                    auth: true,
                },
                component: (resolve) => import("./pages/order/show.vue"),
            },
            {
                path: "order_trademark",
                name: "order_trademark",
                meta: {
                    title: "商标订单中心",
                    auth: true,
                },
                component: (resolve) => import("./pages/order_trademark/index.vue"),
            },
            {
                path: "order_trademark/:id",
                name: "order_trademark.show",
                meta: {
                    title: "商标订单详情",
                    auth: true,
                },
                component: (resolve) => import("./pages/order_trademark/show.vue"),
            },
            {
                path: "contract",
                name: "contract.show",
                meta: {
                    title: "合同管理",
                    auth: true,
                },
                component: (resolve) => import("./pages/contract/index.vue"),
            },
            {
                path: "seller",
                meta: {
                    title: "卖家",
                    auth: true,
                },
                component: (resolve) => import("./pages/seller/index.vue"),
                children: [
                    {
                        path: "resource",
                        meta: {
                            title: "我的店铺",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/seller/resource/index.vue"),
                    },
                    {
                        path: "sale",
                        meta: {
                            title: "我要出售",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/seller/sale/index.vue"),
                    },
                ],
            },
            {
                path: "buyer",
                meta: {
                    title: "买家",
                    auth: true,
                },
                component: (resolve) => import("./pages/buyer/index.vue"),
                children: [
                    {
                        path: "purchased",
                        meta: {
                            title: "我购买的网店",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/buyer/purchased/index.vue"),
                    },
                    {
                        path: "history",
                        meta: {
                            title: "我浏览的店铺",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/buyer/history/index.vue"),
                    },
                    {
                        path: "collect",
                        meta: {
                            title: "我收藏的店铺",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/buyer/collect/index.vue"),
                    },
                ],
            },
            {
                path: "certification/verify",
                name: "verify",
                meta: {
                    title: "实名认证",
                    auth: true,
                },
                component: (resolve) => import("./pages/certification/verify/index.vue"),
            },
            {
                path: "finance",
                name: "财务中心",
                component: (resolve) => import("./pages/finance/index.vue"),
                redirect: "/finance/transaction",
                children: [
                    {
                        path: "transaction",
                        meta: {
                            title: "交易流水",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/transaction/index.vue"),
                    },
                    {
                        path: "recharge",
                        meta: {
                            title: "充值记录",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/finance/recharge/index.vue"),
                    },
                    {
                        path: "expense",
                        meta: {
                            title: "交易记录",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/finance/expense/index.vue"),
                    },
                    {
                        path: "transaction/:transaction_no",
                        meta: {
                            title: "交易明细",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/transaction/show.vue"),
                    },
                    {
                        path: "withdraw",
                        meta: {
                            title: "我要提现",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/withdraw/index.vue"),
                    },
                    {
                        path: "invoice",
                        meta: {
                            title: "我的发票",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/invoice/index.vue"),
                    },
                    {
                        path: "invoice/apply",
                        meta: {
                            title: "发票信息",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/invoice/apply.vue"),
                    },
                    {
                        path: "invoice/verify",
                        meta: {
                            title: "发票信息认证",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/invoice/verify.vue"),
                    },
                ],
            },
            {
                path: "personal",
                component: (resolve) => import("./pages/personal/Index.vue"),
                children: [
                    {
                        path: "profile",
                        meta: {
                            title: "个人资料",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/personal/Profile.vue"),
                    },
                    {
                        path: "bank_card",
                        meta: {
                            middleware: is_verified,
                            title: "绑定银行卡",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/personal/bank_card.vue"),
                    },
                    {
                        path: "password",
                        meta: {
                            title: "修改登录密码",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/personal/Password.vue"),
                    },
                    {
                        path: "password_pay",
                        meta: {
                            title: "修改支付密码",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/personal/password_pay.vue"),
                    },
                    {
                        path: "avatar",
                        meta: {
                            title: "头像上传",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/avatar/Index.vue"),
                    },
                    {
                        path: "mobile",
                        meta: {
                            title: "修改手机号码",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/personal/Mobile.vue"),
                    },
                    {
                        path: "address",
                        meta: {
                            title: "邮寄地址",
                            auth: true,
                        },
                        component: (resolve) => import("./pages/personal/Address.vue"),
                    },
                ],
            },
        ],
    },
    {
        path: "/login",
        name: "login",
        component: (resolve) => import("./pages/auth/Login.vue"),
        meta: {
            title: "登录",
            auth: false,
        },
    },
    {
        path: "/forgot_password",
        name: "forgot_password",
        component: (resolve) => import("./pages/auth/forgot_password.vue"),
        meta: {
            title: "找回密码",
            auth: false,
        },
    },
    {
        path: "/signup",
        name: "signup",
        component: (resolve) => import("./pages/auth/signup.vue"),
        meta: {
            title: "注册",
            auth: false,
        },
    },
    {
        path: "/recharge",
        component: (resolve) => import("./pages/finance/recharge.vue"),
        meta: {
            title: "充值中心",
            auth: true,
        },
    },
    {
        path: "/cashier",
        component: (resolve) => import("./pages/finance/cashier2.vue"),
        meta: {
            title: "收银台",
            auth: true,
        },
    },
    {
        path: "/cashier_trademark",
        component: (resolve) => import("./pages/finance/cashier_trademark.vue"),
        meta: {
            title: "收银台",
            auth: true,
        },
    },
    // {
    //     path: "/cashier2",
    //     component: (resolve) => import("./pages/finance/cashier2.vue"),
    //     meta: {
    //         title: "收银台",
    //         auth: true,
    //     },
    // },
    {
        path: "/recharge/success",
        component: (resolve) => import("./pages/finance/recharge_success.vue"),
        meta: {
            title: "充值成功",
            auth: true,
        },
    },
    {
        path: "/sign_success",
        component: (resolve) => import("./pages/message/sign_success.vue"),
        meta: {
            title: "签署成功",
            auth: false,
        },
    },
    {
        path: "/verify_success",
        component: (resolve) => import("./pages/message/verify_success.vue"),
        meta: {
            title: "实名认证成功",
            auth: false,
        },
    },
    {
        path: "*",
        name: "404",
        meta: {
            title: "404",
            auth: false,
        },
        component: (resolve) => import("./pages/components/404.vue"),
    },
    {
        path: "*",
        // redirect: '/error'
    },
];

//实名认证
function is_verified({ next, store }) {
    if (!store.state.profile.verified_at) {
        return next({
            name: "verify",
        });
    }

    return next();
}
